import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { DesignEditorSecondaryControls } from '../../../DesignEditor/components/DesignEditorControls';
import { CONTROL_SECTION } from '../../helpers';
import CollageDesignerLayoutControls from './components/CollageDesignerLayoutControls';
import CollageDesignerBackgroundControls from './components/CollageDesignerBackgroundControls';

const propTypes = {
  className: PropTypes.string,
  activeControlSection: PropTypes.string.isRequired,
  onCardSettingsUpdate: PropTypes.func.isRequired,
  onElementConfigurationChange: PropTypes.func.isRequired,
  card: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  backgroundElement: PropTypes.shape({
    cardElement: PropTypes.object.isRequired,
    cardElementConfiguration: PropTypes.object.isRequired,
  }),
};

const CollageDesignerSecondaryControlPanel = ({
  className,
  activeControlSection,
  onCardSettingsUpdate,
  onElementConfigurationChange,
  backgroundElement,
  card,
}) => {
  const classes = classNames({
    [className]: !!className,
  });

  return (
    <DesignEditorSecondaryControls className={classes}>
      {activeControlSection === CONTROL_SECTION.LAYOUT && (
        <CollageDesignerLayoutControls
          onCardSettingsUpdate={onCardSettingsUpdate}
          card={card}
        />
      )}
      {activeControlSection === CONTROL_SECTION.BACKGROUND &&
        backgroundElement && (
          <CollageDesignerBackgroundControls
            element={backgroundElement}
            onElementConfigurationChange={onElementConfigurationChange}
          />
        )}
    </DesignEditorSecondaryControls>
  );
};

CollageDesignerSecondaryControlPanel.propTypes = propTypes;

export default CollageDesignerSecondaryControlPanel;
